import { updateItems } from '@/mocks/homeData';

const typeStyles: Record<string, string> = {
  hot: 'bg-primary-100 text-primary-700',
  new: 'bg-accent-100 text-accent-700',
  normal: 'bg-secondary-100 text-secondary-700',
};

const typeLabels: Record<string, string> = {
  hot: '热门',
  new: '新片',
  normal: '动态',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wide mb-3">
            最新动态
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            电影频道快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            最新电影在线资讯实时更新，追新片快人一步
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-200">
            {updateItems.map((item, i) => (
              <div
                key={item.id}
                className={`relative pb-8 ${i === updateItems.length - 1 ? 'pb-0' : ''}`}
              >
                <div className="absolute -left-[25px] md:-left-[29px] top-0 w-3 h-3 rounded-full border-2 border-background-50 bg-primary-500"></div>
                <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
                  <span className="text-xs font-mono text-foreground-400 whitespace-nowrap pt-0.5">
                    {item.date}
                  </span>
                  <div className="flex-1">
                    <span
                      className={`inline-block px-2 py-0.5 rounded text-xs font-medium mb-1.5 ${typeStyles[item.type]}`}
                    >
                      {typeLabels[item.type]}
                    </span>
                    <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
                      {item.title}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}